import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ConfigService } from 'src/app/services/config-service';
import { HttpClientWrapperService } from 'src/app/services/http-client-wrapper.service';

@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss']
})
export class SmsComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private config: ConfigService,
     public http: HttpClientWrapperService
  ) { }

  ngOnInit(): void {
  }

  whitelistForm = this.fb.group({
    client_ip: ['', Validators.required],
    client_name: ['', Validators.required]
  })

  submit(){
    const url = `${this.config.json.apiEndpoint}whitelistClientInfo${this.config.json.apiEndpointSuffix}`
    this.http.post(url, this.whitelistForm.value).subscribe({
      next : (res) =>{
      if((res.api_result as string).toLocaleUpperCase() === 'SUCCESS'){
        alert('Successfully whitelisted')
      }else{
        alert('Failed to whitelist!'+res.error)
      }
      }
    })
  }


}
